import { px2Rem } from '../../../themes/Mixins'
import Button from '../../common/Button'

export const BtnPlay = Button.extend`
  height: ${px2Rem(36)};
  width: ${px2Rem(36)};
  margin: ${px2Rem(29)} 0 0;

  @media (min-width: 768px) {
    width: ${px2Rem(72)};
    height: ${px2Rem(72)};
    margin: ${px2Rem(80)} 0 0;
  };
`




// WEBPACK FOOTER //
// ./src/components/sections/banner/BannerResponsive.js